

























import {Component, Prop, Watch, Vue} from 'vue-property-decorator'
import ErrorFetchingData from "@/components/lfs/NewStatistics/GeneralDashboard/common/ErrorFetchingData.vue";
import Highcharts from "highcharts";
import {locales, zoomText} from "@/helpers/locales";

@Component({
  name: 'ContactsCollectedSchedule',
  components: {ErrorFetchingData}
})

export default class ContactsCollectedSchedule extends Vue {
  @Prop({ type: Object, default: () => { return { allScans: 0 } } }) protected total!: any
  @Prop({ type: Array, default: () => [] }) protected badges!: any
  @Prop({ type: Array, default: () => [] }) protected businessCards!: any
  @Prop({ type: Array, default: () => [] }) protected customContacts!: any
  @Prop({ type: Number, default: () => null }) protected timestampShowStart!: any
  @Prop({ type: Boolean, default: false }) protected loading!: boolean
  @Prop({ type: Boolean, default: false }) protected error!: boolean
  @Prop({ type: Boolean, default: false }) protected isPdf!: boolean
  @Prop({ type: String, default: 'areaspline' }) protected chartType!: string
  @Prop({ type: String, default: '361' }) protected height!: string

  @Watch('loading',{ immediate: true })
  updateData(value: any) {
    if (value) return
    setTimeout(() => this.updateSeries(), 0)
  }
  @Watch('currentLocale', { immediate: true })
  onLocaleChanged(_: any) {
    this.updateLocale()
  }
  get currentLocale() {
    return this.$i18n.locale
  }
  updateLocale() {
    Highcharts.setOptions({
      lang: {
        resetZoom: zoomText[this.currentLocale],
        shortMonths: locales[this.currentLocale]
      }
    })
    this.updateNames()
  }

  protected updateNames(): void {
    this.chartOptions.yAxis.title.text = this.$t('newstatistics.v4.general.contacts_collected.title_chart')
    this.chartOptions.series[0] = {
      ...this.seriesConfig.badges,
      name: this.$t('newstatistics.v4.general.contacts_collected.title'),
      data: this.normalizeChartItem(this.badges)
    }
    this.chartOptions.series[1] = {
      ...this.seriesConfig.businessCards,
      name: this.$t('newstatistics.v4.general.contacts_collected.countSurveys'),
      data: this.normalizeChartItem(this.businessCards)
    }
  }

  protected updateSeries(): void {
    const chart: any = this.$refs.collectedChart
    if (!chart) return
    chart.chart.update({
      series: [
        {
          ...this.seriesConfig.badges,
          data: this.normalizeChartItem(this.badges)
        },
        {
          ...this.seriesConfig.businessCards,
          data: this.normalizeChartItem(this.businessCards)
        },

      ]
    })
  }
  normalizeChartItem(array: any[]) {
    return array.map(((item: any) => [item[0] * 1000, item[1]]))
  }

  seriesConfig = {
    businessCards: {
      type: this.chartType,
      name: this.$t('newstatistics.v4.general.contacts_collected.countSurveys'),
      marker: {
        lineColor: '#6fadda'
      },
      color: '#4D89B5',
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, 'rgba(77, 137, 181, 0.8)' ],
          [1, 'rgba(45, 104, 219, 0.14)']
        ],
      },
    },
    badges: {
      type: this.chartType,
      name: this.$t('newstatistics.v4.general.contacts_collected.title'),
      marker: {
        lineColor: '#CC7D7D'
      },
      color: '#CC7D7D',
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, '#CC7D7D' ],
          [1, 'rgba(255, 0, 0, 0)']
        ],
      },
    },

  }

  chartOptions = {
    lang: {
      shortMonths: ['Янв1', 'Фев1', 'Мар1', 'Апр1', 'Май1', 'Июн1', 'Июл1', 'Авг1', 'Сен1', 'Окт1', 'Ноя1', 'Дек1'],
      weekdays: ["Воскресенье", "Понедельник", "Вторник", "Среда", "Четверг", "Пятница", "Суббота"],
    },
    chart: {
      resetZoomButton:{
        theme: {
          style: {
            color: '#2D9CDB',
            padding: "200px"
          },
          fill: '#F3F2F7',
          stroke: '#2D9CDB',
          strokeWidth: 3,
          r: 5,

        },
        position:{
          x:-5,
          y:-30
        }
      },
      zoomType: 'x',
      type: this.chartType,
      height: this.height,
      style: {"fontSize": "12px"},
      backgroundColor: 'transparent',
      borderRadius: 10,
      marginRight: '5',
      marginTop: '30',
      marginBottom: '50',
      colorCount: 50,
    },
    loading: {
      hideDuration: 1000,
      showDuration: 1000
    },
    title: {
      text: ''
    },
    credits: {
      enabled: false
    },
    tooltip: {
      backgroundColor: null,
      borderWidth: 0,
      shadow: false,
      useHTML: true,
      style: {
        padding: 0
      },
      formatter: function (): any {
        const context: any = this
        const locale: string | null = localStorage.getItem('locale')!
        return '<div class="statistics-v4-tooltip">' + '<span class="statistics-v4-tooltip-title">'
          + new Date(context.x).toLocaleString(locale + '-' + locale.toUpperCase(),{weekday: 'long', month: 'short', day: 'numeric', hour: 'numeric', minute: 'numeric'}) +
          '</span><br><span class="statistics-v4-tooltip-subtitle">'
          + context.point.series.name + ': ' + context.y + '</span></div>'
      },
    },
    xAxis: {
      type: 'datetime',
      labels: {
        overflow: 'justify'
      }
    },
    yAxis: {
      allowDecimals: false,
      title: {
        text: this.$t('newstatistics.v4.general.contacts_collected.title'),
        style: {
          color: '#0A0A0A',
          fontSize: '14px',
          lineHeight: '16px',
          fontWeight: '400',
          fontFamily: 'Inter'
        }
      }
    },
    legend: {
      enabled: true,
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'top',
      x: -10,
      y: 50,
      floating: true,
      borderWidth: 0,
      backgroundColor: 'transparent',
    },
    plotOptions: {
      [this.chartType]: {
        marker: {
          enabled: false,
          symbol: 'circle',
          radius: 3,
          fillColor: 'white',
          lineWidth: 2,
          states: {
            hover: {
              enabled: true
            }
          }
        },
        events: {
          mouseOver: function() {
            const context: any = this
            context.update({
              marker: {
                enabled: true
              }
            });
          },mouseOut: function() {
            const context: any = this
            context.update({
              marker: {
                enabled: false
              }
            });
          }
        },
        lineWidth: 0,
        states: {
          hover: {
            lineWidth: 2,
          }
        },
        threshold: this.total.allScans ? null : '',
        pointStart: this.timestampShowStart,
      },
    },
    series: [
      {
      ...this.seriesConfig.badges,
        data: this.normalizeChartItem(this.badges),
      },
      {
        ...this.seriesConfig.businessCards,
        data: this.normalizeChartItem(this.businessCards),
      }
    ]
  }
}
